var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8383_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 61.4998C123 95.4653 95.4657 123 61.5002 123C27.5347 123 0.000199471 95.4653 0.000199471 61.4998C0.000199471 27.5343 27.5347 -0.000164214 61.5002 -0.000164214C95.4657 -0.000164214 123 27.5343 123 61.4998Z",
    fill: "#7FFAA1",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2566 90.6836L73.7208 71.7293C76.1464 68.9741 77.5 65.3104 77.5 61.5C77.5 57.6896 76.1464 54.0259 73.7208 51.2707L56.2566 32.3164C55.1848 31.1534 53.7311 30.5 52.2153 30.5C50.6995 30.5 49.2458 31.1534 48.174 32.3164C47.1021 33.4794 46.5 35.0568 46.5 36.7016C46.5 38.3464 47.1021 39.9238 48.174 41.0868L65.6419 60.041C65.999 60.4286 66.1995 60.9541 66.1995 61.5021C66.1995 62.05 65.999 62.5756 65.6419 62.9631L48.174 81.9132C47.1021 83.0762 46.5 84.6536 46.5 86.2984C46.5 87.9432 47.1021 89.5206 48.174 90.6836C49.2458 91.8466 50.6995 92.5 52.2153 92.5C53.7311 92.5 55.1848 91.8466 56.2566 90.6836Z",
    fill: "#7FFAA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8383_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGreen);
export default __webpack_public_path__ + "static/media/arrow-right-green.d878caeaee457cc693ffbef9da4a7ec6.svg";
export { ForwardRef as ReactComponent };